/* Pixel Meta (Facebook) — chargé uniquement si REACT_APP_META_PIXEL_ID est
   défini dans frontend/.env. Suit PageView automatiquement ; exposer
   trackMetaEvent() pour les conversions (ex : CompleteRegistration). */

export const initMetaPixel = () => {
  const pixelId = process.env.REACT_APP_META_PIXEL_ID;
  if (!pixelId || window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
};

export const trackMetaEvent = (eventName, params = {}) => {
  if (window.fbq) window.fbq('track', eventName, params);
};
